import { memo, useEffect } from 'react';
import ButtonCarousel from '@JohnLewisPartnership/jl-design-system/components/button-carousel/ButtonCarousel';
import PropTypes from 'prop-types';
import styles from './FilterSuggestions.module.scss';

import StatefulLink from '../stateful-link/StatefulLink';
import {
  FILTER_APPLIED,
  dispatchAnalyticsEvent,
} from '../analytics/analyticsEvents';
import { useFilterSuggestionsData } from './data/useFilterSuggestionsData';

const MIN_SUGGESTIONS = 2;

export const isFilterSuggestionsDisplayed = (filterSuggestions, pageType) =>
  filterSuggestions?.length >= MIN_SUGGESTIONS && pageType !== 'brand';

const FilterSuggestions = memo(({ pageType }) => {
  const { filterSuggestions, facetContext } = useFilterSuggestionsData();
  const { applied } = facetContext;

  const MAX_SUGGESTIONS = 7;

  useEffect(() => {
    const buttonCarouselEl = document.querySelector('.filter-suggestions');
    if (buttonCarouselEl?.scroll) {
      buttonCarouselEl.scroll(0, 0);
    }
  }, [filterSuggestions]);

  if (!isFilterSuggestionsDisplayed(filterSuggestions, pageType)) {
    return null;
  }

  const triggerAnalyticsEvent = (filter, position) => {
    const page =
      pageType === 'browse' ? 'product list page grid' : 'search results';

    const { facetGroupName, facetName, trackingId } = filter;
    const appliedFilter = `${facetGroupName}:${facetName}`.toLowerCase();
    const newFilterCombination = applied?.filterCombination
      ? `${applied.filterCombination}|${appliedFilter}`
      : appliedFilter;
    const newFilterCombinationNvals = applied?.filterCombinationNvals
      ? `${applied.filterCombinationNvals}|${trackingId}`
      : trackingId;

    dispatchAnalyticsEvent(FILTER_APPLIED, {
      pagetype: page,
      filterCombination: newFilterCombination,
      filterCombinationNvals: newFilterCombinationNvals,
      appliedFilter,
      appliedFilterNval: trackingId,
      additionalInfo: {
        isHorizontal: 'true',
        horizontalPosition: position.toString(),
      },
    });
  };

  const buttonList = filterSuggestions
    .slice(0, MAX_SUGGESTIONS)
    .map((filter, idx) => ({
      buttonKey: `${idx}${filter.display}`,
      tag: StatefulLink,
      href: '/',
      facetId: filter.facetId,
      query: { page: undefined },
      children: filter.display,
      onClick: () => {
        triggerAnalyticsEvent(filter, idx + 1);
      },
    }));

  return (
    <div className={styles.container}>
      <ButtonCarousel
        className="filter-suggestions"
        buttonList={buttonList}
        ariaLabel="Frequently used filters"
      />
    </div>
  );
});

FilterSuggestions.displayName = 'FilterSuggestions';

FilterSuggestions.propTypes = {
  pageType: PropTypes.string,
};

export default FilterSuggestions;
